import React, { useRef, useState, useContext } from 'react';
import { useAuth } from '../contexts/AuthContext';
import ToastContext from '../contexts/ToastContext';
import { useNavigate, Link } from 'react-router-dom';
import '../styles/Login.css';

export default function Login() {
  const emailRef = useRef();
  const passwordRef = useRef();
  const { login } = useAuth();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const toast = useContext(ToastContext);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(emailRef.current.value, passwordRef.current.value);
      // show success toast then navigate (if provider present)
  if (toast && toast.success) toast.success('Connecté');
      navigate('/');
    } catch (err) {
      const friendly = err && err.message === 'Failed to fetch'
        ? "Impossible de contacter le serveur. Vérifiez la connexion réseau."
        : (err.message || 'Erreur inconnue');
      setError(friendly);
      if (toast && toast.error) toast.error(friendly);
    }
    setLoading(false);
  }

  return (
    <div className="container">
      <div className="card" style={{maxWidth:480,margin:'1rem auto'}}>
        <h2>Connexion</h2>

        {error && (
          <div role="alert" className="card headerless" style={{background:'rgba(239,68,68,0.04)',borderLeft:'4px solid var(--danger)',marginBottom:'12px'}}>
            <div style={{color:'var(--danger)'}}>{error}</div>
          </div>
        )}

        <form onSubmit={handleSubmit} aria-label="form-connexion">
          <div className="field">
            <label className="muted">Email</label>
            <input className="input" type="email" ref={emailRef} required aria-required="true" />
          </div>

          <div className="field password-field">
            <label className="muted">Mot de passe</label>
            <div className="input-with-icon">
              <input className="input" type={showPassword ? 'text' : 'password'} ref={passwordRef} required aria-required="true" />
              <button type="button" className="password-toggle" onClick={() => setShowPassword(v => !v)} aria-label={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}>
                {showPassword ? '👁️' : '👁️'}
              </button>
            </div>
          </div>

          <div className="actions-row">
            <Link to="/forgot-password" className="forgot-link">Mot de passe oublié?</Link>
            <button className="login-btn" disabled={loading} type="submit">{loading ? 'Connexion...' : 'Se connecter'}</button>
          </div>
        </form>

        <div style={{marginTop: '20px', textAlign: 'center', borderTop: '1px solid #eee', paddingTop: '20px'}}>
          <p style={{marginBottom: '10px'}}>Pas encore inscrit?</p>
          <Link to="/register" className="btn btn-outline" style={{textDecoration: 'none'}}>
            Créer un compte
          </Link>
        </div>
      </div>
    </div>
  );
}
